import React, { useEffect, useState } from "react";
import {
  Heading,
  Text,
  Box,
  Spinner,
  VStack,
  Grid,
  GridItem,
  useColorModeValue,
  Flex,
  Avatar,
} from "@chakra-ui/react";
import AppLayout from "../components/layout/AppLayout";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Dashboard = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const cardBg = useColorModeValue("white", "gray.800");
  const labelColor = useColorModeValue("gray.600", "gray.400");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  useEffect(() => {
    const token = localStorage.getItem("token");
    let attempts = 0;

    const fetchUser = async () => {
      if (!token) {
        console.error("No token found");
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(`${API_BASE}/auth/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const text = await res.text();
        try {
          const data = JSON.parse(text);
          setUser(data);

          // If Stripe ID is missing, try again (max 5 times)
          if (!data.stripe_customer_id && attempts < 5) {
            attempts++;
            setTimeout(fetchUser, 2000); // Retry in 2 seconds
          } else {
            setLoading(false);
          }
        } catch (parseErr) {
          console.error("Invalid JSON:", text);
          throw parseErr;
        }
      } catch (err) {
        console.error("Error loading user data:", err);
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  if (loading) {
    return (
      <AppLayout>
        <VStack justify="center" align="center" h="100%">
          <Spinner size="xl" />
        </VStack>
      </AppLayout>
    );
  }

  const fullName =
    user?.first_name || user?.last_name
      ? `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim()
      : "N/A";

  return (
    <AppLayout>
      <Box px={8} py={10}>
        <Heading size="lg" mb={6}>
          Welcome to ShelfKey
        </Heading>

        <Box
          bg={cardBg}
          p={6}
          rounded="xl"
          shadow="md"
          maxW="lg"
          border="1px solid"
          borderColor={borderColor}
        >
          <Flex align="center" mb={6}>
            <Avatar
              name={fullName}
              size="lg"
              mr={4}
              bg="#1C4C3F"
              color="white"
            />
            <Box>
              <Text fontSize="lg" fontWeight="bold">
                {fullName}
              </Text>
              <Text fontSize="sm" color="gray.500">
                {user?.email}
              </Text>
            </Box>
          </Flex>

          <Grid templateColumns="1fr 2fr" rowGap={4} columnGap={6}>
            <GridItem>
              <Text fontWeight="medium" color={labelColor}>
                Company
              </Text>
            </GridItem>
            <GridItem>
              <Text>{user?.company_name || "N/A"}</Text>
            </GridItem>

            <GridItem>
              <Text fontWeight="medium" color={labelColor}>
                Plan
              </Text>
            </GridItem>
            <GridItem>
              <Text>{user?.plan_name || "Starter"}</Text>
            </GridItem>

            <GridItem>
              <Text fontWeight="medium" color={labelColor}>
                User ID
              </Text>
            </GridItem>
            <GridItem>
              <Text>{user?.id}</Text>
            </GridItem>
          </Grid>
        </Box>
      </Box>
    </AppLayout>
  );
};

export default Dashboard;
